
import helperPageLock from 'shared/mixins/helper-page-lock';
import helperA11y     from 'shared/mixins/helper-a11y';

/**
 * @module
 * search input keydown
 */
 
const selector = '[data-js-search-input]';
const searchInput = function(el, app) {

    const pageLockHelper = helperPageLock(app);
    const a11yHelper = helperA11y(app);
    
    const $document = $(document);
    const $input = $(el);
    const $mask = $('[data-js-search-mask]');
    const $inner = $('[data-js-search-inner]');
    const $fake = $('[data-js-search-fake]');
    const $extra = $('[data-js-search-extra]');
    const $buttonGo = $('[data-js-search-submit]');
    const $buttonOpen = $('[data-js-search-open]');
    const $buttonClose = $('[data-js-search-close]');
    let   statusInput = false;
    let   placeholder = null;
    let   urlToSearch = null;
    let   urlParameter = null;
    let   minWidth = 0;
    let   searchIndexArray = ( typeof searchIndex !== 'undefined' ? searchIndex : [] ); // inline search index, embedded in page
    let   searchIndexArrayNormal = [];
    let   submitBlock = false;
    
    // GO!!
    const init = function() {
        // get the url and the keyword parameter name from the markup (much better than embedding it in JS)
        urlToSearch = $inner.attr('action');
        urlParameter = $input.attr('name');
        // fix a min width to the input
        minWidth = $input[0].offsetWidth;
        $fake.css('min-width',minWidth + 'px');
        // warm up the search index
        searchIndexArrayNormal = cleanForSearch(searchIndexArray);
        // misc other set-up
        placeholder = $input.attr('placeholder');
        // set up the events
        registerEvents();
    };

    const registerEvents = function() {
        // open/close search box
        $buttonOpen.on('click',open);
        $buttonClose.on('click',close);
        $mask.on('click',close);
        // typing in the input
        $input.on('keydown blur',fakeCentering);
        $input.on('keyup',extraSearch);
        $input.on('keyup',submitButtonStatus);
        // keyboard events (escape, arrow up/down)
        $document.on('keyup', escapeSearch);
        $document.on('keyup', arrowResults);
        // clicking on quicksearch results
        $document.on('click', '[data-js-search-result]', submitQuicksearch);
        // submit
        $inner.on('submit', submit);

        /* RESULTS FORM */

        $input.on('keyup',submitButtonStatus);
    };
    
    // kill a search when the escape key is hit and a pop is open.
    const escapeSearch = function(ev) {
        if(statusInput && ev && ev.keyCode == 27){
            close(ev);
        }
    };
    
    // use arrow keys to navigate up and down a list of results
    const arrowResults = function(ev) {
        const $results = $('[data-js-search-result]');
        if(statusInput && ev) {
            const currentFocus =  document.activeElement;
            if (ev.keyCode == 40){
                ev.preventDefault();
                const $nextResult = $results.get($results.index(currentFocus) + 1);
                if ($nextResult) {
                    $nextResult.focus();
                }
            } else if (ev.keyCode == 38){
                ev.preventDefault();
                const $prevResult = $results.get($results.index(currentFocus) - 1);
                if ($results.index(currentFocus) !== 0 && currentFocus.tagName !== 'INPUT') {
                    $prevResult.focus();
                } else {
                    $input.focus().select();
                }
            }
        }
    };

    // normalise any keyword (entered or indexed) to strip any possible inconsistancies.
    const cleanForSearch = function(input,notSpaces) {
        // array
        if (typeof input === 'object') {
            return input.map(function(el) {
                return cleanForSearch(el);
            });
        // string
        } else {
            let output = input.replace(/[^\w\söåä]|_/g, "").toLowerCase();
            if (!notSpaces) {
                output = output.replace(/\s+/g, "");
            }
            return output;
        }
    };

    // a mechnanism to center the search input on the screen. 
    // When a character is entered, it's also entered into a hidden <SPAN>, which controls the width of the centred div (via the input being absolutely positioned inside a flexible div)
    const fakeCentering = function() {
        const val = $input.val();
        if (val.length) {
            $fake.text(val);
        } else {
            $fake.text(placeholder);
        }
    };

    // show/hide the "submit" button, depending on if the input is empty or not. Also close the extra results div if nothing in the  search input
    const submitButtonStatus = function() {
        const val = $input.val();
        if (val.length) {
            $buttonGo.addClass('Ge-Search-Submit--active');
        } else {
            $buttonGo.removeClass('Ge-Search-Submit--active');
            extraClose();
        }
    }

    // open the search input
    const open = function(ev) {
        // kill the link to the search page
        ev.preventDefault();
        // CSS open
        $inner.addClass('Ge-Search-Drop-Inner--active');
        $mask.addClass('Ge-Search-Mask--active');
        // reveal internal input elements to accessibility/tabbing
        a11yHelper.show($inner);
        // lock the page scroll
        pageLockHelper.on();
        // focus on the input to bring up software keyboard/start text cursor flashing
        $input.focus();
        // done
        statusInput = true;
        // ga
        app.trigger('beacon','search-header-open');
    };

    // close the search input
    const close = function() {
        // kill any content in the results shelf
        extraClose();
        // reset the search input
        $input.val('');
        $fake.text(placeholder);
        // CSS close
        $inner.removeClass('Ge-Search-Drop-Inner--active');
        $mask.removeClass('Ge-Search-Mask--active');
        // refocus on the open button (to help accessibility - locates where the keyboard focus is)
        $buttonOpen.focus(); 
        // hide all the internal input elements from accessibilty/tabbing
        a11yHelper.hide($inner);
        // unloock the page scroll
        pageLockHelper.off();
        // done.
        statusInput = false;
    };

    // test any keywords entered against an inline common keyword array, and prioritise the the results
    const extraSearch = function() {
        
        // clean the keywords that are being searched on.
        const keywords = cleanForSearch($input.val(),true);
        let   indexFoundArray = [];

        // if the keyword entered is not a single letter (eg "el" ✔︎ but "e" ✗)
        if (keywords.trim().length >= 2) {
            // split keywords into each keyword (eg "din el" = ["din", "el"])
            const keywordsArray = keywords.trim().split(' ');
            let   foundCounter = 0;
            const deDupeArray = [];
            // for each keyword (eg "din" of ["din", "el"])
            for(let i = 0; i < keywordsArray.length; i++) {
                const singleKeyword = keywordsArray[i];
                // each keyword shouldn't be a single letter (eg "el" ✔︎ but "e" ✗)
                if (singleKeyword.trim().length >= 2) {
                    // for each entry in the index
                    for(let j = 0; j < searchIndexArrayNormal.length; j++) {
                        const singleIndex = searchIndexArrayNormal[j];
                        const foundPosition = singleIndex.indexOf(singleKeyword);
                        // does this keyword match any indexed keywords?
                        if (foundPosition >= 0) {
                            // check the dedupe array to make sure it wasn't already found, if it was (and it was at the start of the indexed keyword), priotize the existing result, don't add another
                            const deDupeIndex = deDupeArray.indexOf(singleIndex);
                            if (deDupeIndex >= 0) {
                                // top pritority
                                indexFoundArray[deDupeIndex].priority = 100;
                            } else {
                                // prio: low is default
                                let prio = 0;
                                // prio: top: the keyword matches the indexed word exactly
                                if (singleKeyword === singleIndex) {
                                    prio = 75;
                                // prio: mid: any search keyword found at the start of this indexed keyword
                                } else if (i === 0 && foundPosition === 0) {
                                    prio = 50;
                                // prio: mid: any search keyword found at the start of this indexed keyword
                                } else if (foundPosition === 0) {
                                    prio = 25;
                                // prio: mid: prioritise first keyword over any further kewords
                                } else if (i === 0) {
                                    prio = 10;
                                }
                                indexFoundArray[foundCounter] = {
                                    "index" : j,
                                    "normalized" : singleIndex,
                                    "original" : searchIndexArray[j],
                                    "priority": prio, 
                                    "compare" : singleKeyword
                                };
                            }
                            deDupeArray[foundCounter] = singleIndex;
                            foundCounter++;
                        }

                    }
                }
            }
        }
        // nothing found?
        if (!indexFoundArray.length) {
            extraClose();
            return;
        }
        // reverse sort the results so the prioritised ones come to the top.
        indexFoundArray = indexFoundArray.sort(function (a, b) {
            return a.priority - b.priority;
        });
        indexFoundArray = indexFoundArray.reverse();
        // build the results
        extraBuild(indexFoundArray);
    };

    // after we've retrieved the list of results from the quicksearch, print it.
    const extraBuild = function(foundArray) {
        const $container = $('[data-js-search-extra-inner]');
        const $searchResultsA11y = $('[data-js-search-results-a11y]');
        let buffer = '<ul class="Ge-Search-Drop-Extra-List">';
        for (let i=0; i<foundArray.length; i++) {
            const node = foundArray[i];
            if (node && typeof node.original !== 'undefined') {
                buffer += `
                <li class="Ge-Search-Drop-Extra-Item">
                    <a href="${urlToSearch}?${urlParameter}=${node.original}" class="Ge-Search-Drop-Extra-Link" data-js-search-result>
                        <svg viewBox="0 0 512 512" class="Ge-Icon Ge-Search-Drop-Extra-Magnify">
                            <use xlink:href="#icon_small-magnify"></use>
                        </svg>
                        <span class="Ge-Search-Drop-Extra-Text">${node.original}</span>
                        <svg viewBox="0 0 512 512" class="Ge-Icon Ge-Search-Drop-Extra-Arrow">
                            <use xlink:href="#chevron-disc-right"></use>
                        </svg>
                    </a>
                </li>`;
            }
        }
        $searchResultsA11y.text(foundArray.length + ' resultat hittades.');
        $container.html(buffer);
        // we have results. reveal them.
        extraOpen();
    };

    // show the quick search results
    const extraOpen = function() {
        $extra.addClass('Ge-Search-Drop-Extra--active');
    };

    // hide the quick search results
    const extraClose = function() {
        $extra.removeClass('Ge-Search-Drop-Extra--active');
    };

    const submit = function(ev) {
        if (!submitBlock) {
            // halt and catch fire
            ev.preventDefault();
            // submit in 50ms (get it in before any adblocker potentially kills the GA line)
            submitBlock = true;
            setTimeout(function() {
                $(this).submit();
            },50);
            // ga
            app.trigger('beacon','search-header-submit');
            return false;
        }
        return true;
    };

    const submitQuicksearch = function(ev) {
        const link = this;
        const searchLink = link.href;
        // halt and catch fire
        ev.preventDefault();
        // submit in 50ms (get it in before any adblocker potentially kills the GA line)
        setTimeout(function() {
            self.location = searchLink;
        },50);
        // ga
        app.trigger('beacon','search-header-quicksearch,' + $(link).find('.Ge-Search-Drop-Extra-Text').text().replace(',',''));
        return false;
    };

    return {
        init: init()
    };
};

searchInput.selector = selector;

export default searchInput;
